// src/api/axios.js
import axios from 'axios'
import { URL_CONFIG } from './config'

// ========== 辅助函数：强制转换为字符串 ==========
function forceString(value, defaultValue = '/dev-api') {
  if (typeof value === 'string') return value;
  if (value === null || value === undefined) return defaultValue;
  if (typeof value === 'object') {
    if (value.href) return value.href;
    if (value.pathname) return value.pathname;
    if (value.origin && value.pathname) return value.origin + value.pathname;
    return defaultValue;
  }
  return String(value);
}

// ========== 创建实例 ==========
const baseApiUrl = forceString(URL_CONFIG.baseApiUrl);
console.log('🔥 baseApiUrl:', baseApiUrl, '类型:', typeof baseApiUrl);

export const authHttp = axios.create({
  baseURL: forceString(URL_CONFIG.authApiUrl),
  timeout: 30000
})

export const adminHttp = axios.create({
  baseURL: forceString(URL_CONFIG.adminApiUrl),
  timeout: 30000
})

export const aicsHttp = axios.create({
  baseURL: baseApiUrl,
  timeout: 30000
})

export const ssoHttp = axios.create({
  baseURL: forceString(URL_CONFIG.ssoApiUrl),
  timeout: 30000
})

// 兼容旧导出
export const http = aicsHttp

// ========== 为所有实例添加请求拦截器，确保 url 是字符串 ==========
// 注意：ssoHttp 可能有自己的拦截器，所以单独处理
const instances = [aicsHttp, authHttp, adminHttp];

instances.forEach(instance => {
  if (instance && instance.interceptors) {
    instance.interceptors.request.use(config => {
      // 确保 url 是字符串
      if (config.url && typeof config.url === 'object') {
        console.warn('⚠️ config.url 是对象，正在修复:', config.url);
        config.url = config.url.pathname || config.url.href || String(config.url);
      }
      if (typeof config.url !== 'string') {
        config.url = String(config.url || '');
      }
      return config;
    });
  }
});

// ssoHttp 单独处理
if (ssoHttp && ssoHttp.interceptors) {
  ssoHttp.interceptors.request.use(config => {
    // 如果是 FormData，让浏览器自动设置 Content-Type
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    // 确保 url 是字符串
    if (config.url && typeof config.url === 'object') {
      config.url = config.url.pathname || config.url.href || String(config.url);
    }
    if (typeof config.url !== 'string') {
      config.url = String(config.url || '');
    }
    return config;
  });
}